import { _addonUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to add a teleradiology customer
export const updateAddons = createAsyncThunk(
  'updateAddons',
  async (pacData: any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_addonUrls.update, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pacData),
      });

      if (!response.ok) {
        return rejectWithValue('Failed to update plans');
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);
